// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"DepositForm_formWrapper__2AC9U","title":"DepositForm_title__1pl0T","input":"DepositForm_input__1Geif","form":"DepositForm_form__3ZCdr"};